/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
import http from "../../auth/http-common";

import { URL } from "../../constants/api-constants";

const getCount = async (): Promise<number | undefined> => {
  try {
    const response = await http.get(URL.ADMINS_COUNT);
    return response.data.count;
  } catch (error) {
    console.error(error);
  }
};

const getIdentity = async () => {
  try {
    const response = await http.get(URL.CURRENT_ADMIN);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const resetPassword = async (id: string, password: string): Promise<void> => {
  await http.put(`/admins/${id}/reset-password`, { password });
};

const changePassword = async (currentPassword: string, newPassword: string): Promise<void> => {
  await http.post("/admins/change-password", { currentPassword, newPassword });
};

export const adminsProvider = {
  getCount,
  getIdentity,
  resetPassword,
  changePassword,
};
